import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Typography,
    IconButton,
    Tooltip,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { Close, HelpOutline } from "@mui/icons-material";

const DialogConfirmWrapper = ({
    openPopup = false,
    onClose,
    titleMessage,
    descriptionMessage,
    popupMessage,
    confirmLabel = "Confirm",
    isLoading,
    onConfirm,
    showConfirm = true,
    showCancel = true,
    showAction = true,
    size = "xs",
    additionalButtonLabel = null,
    onAdditionalButtonClick = null,
    confirmButtonVisible = true,
    cancelButtonVisible = true,
    cancelLabel = "Cancel",
    onCancelButtonClick = null,
    additionalButtonHelpText = null,
    startIcon = null,
    buttonHelpText = null,
    confirmButtonDisabled = false,
    buttonAlignment = "start",
    PaperProps = {},
    confirmStartIcon = null,
    otherActions = null,
    confirmButtonColor = "secondary",
    dataTestId = {
        confirmButtonId: null,
        cancelButtonId: null,
        closeIconId: null,
    },
    disableBackdropClose = false,
    sx={}
}) => {
    return (
        <Dialog
            open={openPopup}
            onClose={(event, reason) => {
                if (disableBackdropClose && reason === "backdropClick") return;
                onClose(event, reason);
            }}
            fullWidth
            maxWidth={size}
            sx={{
                "& .MuiDialog-paper": {
                    p: 0,
                    borderRadius: 2,
                },
                "& .MuiPaper-root": {
                    overflowX: "hidden",
                },
                ...sx
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: "1rem",
                    bgcolor: "secondary.main",
                    color: "#fff",
                    p: "12px 16px",
                }}
            >
                <div
                    style={{
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: '8px',
                        height: "24px",
						margin: '0',
						fontSize: '0.875rem',
						fontWeight: '600',
						lineHeight: 1.334,
						
                    }}
                >
                    {startIcon} {titleMessage}
                </div>
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    color: "#fff",
                }}
            >
                <Close />
            </IconButton>

            <DialogContent dividers sx={{ borderTop: 0, px: 2, py: 3 }}>
                <Grid container spacing={2}>
                    {descriptionMessage && (
                        <Grid item xs={12} className="description-message">
                            {typeof descriptionMessage === "string" ? (
                                <Typography>{descriptionMessage}</Typography>
                            ) : (
                                descriptionMessage
                            )}
                        </Grid>
                    )}
                    {popupMessage && (
                        <Grid item xs={12} className="popup-message">
                            {typeof popupMessage === "string" ? (
                                <Typography>{popupMessage}</Typography>
                            ) : (
                                popupMessage
                            )}
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            {showAction && (
                <DialogActions sx={{ p: 2, justifyContent: "end" }}>
                    {showCancel && (
                        <LoadingButton
                            disableElevation
                            size="large"
                            type="button"
                            variant="outlined"
                            color="secondary"
                            {...(dataTestId?.cancelButtonId && {
                                "data-testid": dataTestId?.cancelButtonId,
                            })}
                            onClick={() => {
                                if (onCancelButtonClick) {
                                    onCancelButtonClick();
                                } else {
                                    onClose();
                                }
                            }}
                            sx={{
                                visibility: cancelButtonVisible
                                    ? "visible"
                                    : "hidden",
                            }}
                        >
                            {cancelLabel}
                        </LoadingButton>
                    )}

                    {otherActions}

                    {additionalButtonLabel !== null && (
                        <LoadingButton
                            disableElevation
                            size="large"
                            type="button"
                            variant="contained"
                            color="secondary"
                            loading={isLoading}
                            onClick={onAdditionalButtonClick}
                            sx={{
                                visibility: confirmButtonVisible
                                    ? "visible"
                                    : "hidden",
                            }}
                            {...(additionalButtonHelpText && {
                                endIcon: (
                                    <Tooltip
                                        title={additionalButtonHelpText}
                                        sx={{ cursor: "pointer" }}
                                    >
                                        <HelpOutline fontSize="small" />
                                    </Tooltip>
                                ),
                            })}
                        >
                            {additionalButtonLabel}
                        </LoadingButton>
                    )}

                    {showConfirm === true && (
                        <LoadingButton
                            disableElevation
                            size="large"
                            type="button"
                            variant="contained"
                            color={confirmButtonColor}
                            loading={isLoading}
                            onClick={onConfirm}
                            {...(confirmStartIcon && {
                                startIcon: confirmStartIcon
                            })}
                            disabled={confirmButtonDisabled}
                            {...(dataTestId?.confirmButtonId && {
                                "data-testid": dataTestId?.confirmButtonId,
                            })}
                            sx={{
                                visibility: confirmButtonVisible
                                    ? "visible"
                                    : "hidden",
                            }}
                            {...(buttonHelpText && {
                                endIcon: (
                                    <Tooltip
                                        title={buttonHelpText}
                                        sx={{ cursor: "pointer" }}
                                    >
                                        <HelpOutline fontSize="small" />
                                    </Tooltip>
                                ),
                            })}
                        >
                            {confirmLabel}
                        </LoadingButton>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default DialogConfirmWrapper;
